import React from 'react';
import { Typography } from 'seagull';
import { formatShortMonthUSDate } from "../../../../utils";
import styles from "./TimeActivityDetails.module.scss";
export const TimeActivityDetails = _ref => {
  let {
    timeActivity: {
      id,
      date,
      hours,
      minutes,
      note
    }
  } = _ref;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: styles.timeActivityRow
  }, /*#__PURE__*/React.createElement(Typography, {
    className: styles.timeActivityLabel
  }, 'Date: '), /*#__PURE__*/React.createElement(Typography, {
    "data-testid": "time-activity-".concat(id, "-date")
  }, formatShortMonthUSDate(new Date(date)))), /*#__PURE__*/React.createElement("div", {
    className: styles.timeActivityRow
  }, /*#__PURE__*/React.createElement(Typography, {
    className: styles.timeActivityLabel
  }, 'Duration: '), /*#__PURE__*/React.createElement(Typography, {
    "data-testid": "time-activity-".concat(id, "-duration")
  }, "".concat(hours, " hrs ").concat(minutes, " mins"))), /*#__PURE__*/React.createElement("div", {
    className: styles.timeActivityRow
  }, /*#__PURE__*/React.createElement(Typography, {
    className: styles.timeActivityLabel
  }, 'Notes: '), /*#__PURE__*/React.createElement(Typography, {
    "data-testid": "time-activity-".concat(id, "-note"),
    className: styles.notes
  }, note)));
};